<script>
import PageImage from "../pages/page-image";
import InventoryDetails from "../inventories/inventory-details";
import PersonDetails from "@/components/persons/person-details";
import PersonInline from "@/components/persons/person-inline.vue";


/**
 * Nav-bar Component
 */
export default {
  components: {
    PersonInline,
    PageImage,
    InventoryDetails,
    PersonDetails,
  },
  props: {
    page: {
      type: Object,
      required: true,
    },
    withCommentaire: {
      type: Boolean,
      default: true
    },
    withInscription: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      singleImage: false,
      displayInventory: false,
      displayPerson: false,
      displayedInventory: null,
      selectedPerson: null
    };
  },
  methods: {
    formatAdresse(item) {
      let adresse = '';

      if (item.Adresse !== '' && item.Adresse !== ' ')
        adresse += `<a href="#">${item.Adresse}</a>`;
      if (item.Ville !== '' && item.Ville !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + `<a href="#">${item.Ville}</a>`;
      if (item.Region !== '' && item.Region !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + `<a href="#">${item.Region}</a>`;
      if (item.Pays !== '' && item.Pays !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + `<a href="#">${item.Pays}</a>`;

      return adresse;
    },
    formatDate(item) {
      let date = '';

      if (item.DateJour !== '' && item.DateJour !== ' ')
        date += item.DateJour;
      if (item.DateMois !== '' && item.DateMois !== ' ')
        date += (date !== '' ? '/' : '') + item.DateMois;
      if (item.DateAnnee !== '' && item.DateAnnee !== ' ')
        date += (date !== '' ? '/' : '') + item.DateAnnee;
      if (item.DetailDate !== '' && item.DetailDate !== ' ')
        date += (date !== '' ? ', ' : '') + item.DetailDate;

      return date;
    },
    formatTheme(item) {
      let theme = '';

      if (item.Theme !== '' && item.Theme !== ' ')
        theme += `<a href="#">${item.Theme}</a>`;
      if (item.DetailTheme !== '' && item.DetailTheme !== ' ')
        theme += (theme !== '' ? ', ' : '') + item.DetailTheme;

      return theme;
    },
    getNumAlbum(item) {
      let imageNumber = item.NumPageAlbum;
      let annee = imageNumber.substr(imageNumber.length - 2);

      return '19' + annee;
    },
    isBis() {
      return this.page.NumPageAlbum.match(/bis|ter/i) !== null;
    }
  }
};
</script>

<template>
  <b-card no-body class="mb-0" :class="this.isBis() ? 'bg-info bg-soft' : ''">
    <b-row no-gutters class="align-items-center">
      <b-col cols="12">
        <page-image :page="page"></page-image>
      </b-col>
      <b-col cols="12">
        <b-card-body>
          <b-card-title>
            <h5 class="card-title">{{ page.NumPageAlbum }}
              <span
                  v-if="this.isBis()"
                  role="button"
                  class="badge bg-info font-size-11 m-1 float-end"
              >
            BIS
            </span>
            </h5>
          </b-card-title>

          <ul class="list-inline">
            <li class="list-inline-item me-3">
              <a role="button" class="text-muted">
                <i class='bx bx-photo-album'></i> {{ getNumAlbum(page) }}
              </a>
            </li>
            <li class="list-inline-item me-3">
              <a role="button" class="text-muted">
                <i class='bx bx-calendar'></i> <span v-html="formatDate(page)"></span>
              </a>
            </li>
            <li class="list-inline-item me-3" v-if="formatAdresse(page) !== ''">
              <a role="button" class="text-muted">
                <i class='bx bx-map'></i> <span v-html="formatAdresse(page)"></span>
              </a>
            </li>
            <li class="list-inline-item me-3" v-if="formatTheme(page) !== ''">
              <a role="button" class="text-muted">
                <i class='bx bx-purchase-tag'></i> <span v-html="formatTheme(page)"></span>
              </a>
            </li>
          </ul>

          <b-card-text v-if="page.inventories && page.inventories.length">
            <i class='bx bx-hash'></i>
            <span
                v-for="(inventory, key) in page.inventories"
                :key="key"
            >
              <a role="button" @click="displayedInventory = inventory; displayInventory = true"
                 class="text-info ms-2">{{ inventory.inventory_number }}</a>
            </span>
          </b-card-text>

          <div v-if="page.persons">
            <template v-for="person in page.persons">
              <person-inline :value="person" :key="person.id"></person-inline>
            </template>
          </div>

          <div class="card-text" v-if="withInscription && page.Inscription !== ' '">
            <h6>Inscription</h6>
            <blockquote class="blockquote">
              {{ page.Inscription }}
            </blockquote>
          </div>
          <div class="card-text" v-if="withCommentaire && page.Commentaire !== ' '">
            <h6>Commentaire</h6>
            <blockquote class="blockquote">
              {{ page.Commentaire }}
            </blockquote>
          </div>
        </b-card-body>
      </b-col>
    </b-row>

    <b-modal centered hide-footer
             v-model="displayInventory"
             size="xl"
             title-class="font-18"
             @hide="displayedInventory = null">
      <inventory-details v-if="displayedInventory" :resource="displayedInventory"></inventory-details>
    </b-modal>

    <b-modal centered hide-footer
             v-model="displayPerson"
             size="md"
             title-class="font-18"
             @hide="selectedPerson = null">
      <person-details v-if="selectedPerson" :person="this.selectedPerson"></person-details>
    </b-modal>
  </b-card>
</template>
